import React from 'react';
import {
  InputPrefix,
  InputSuffix,
  TextArea as KendoTextArea,
  TextAreaChangeEvent
} from '@progress/kendo-react-inputs';

type KendoReactTextAreaProps = {
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  disabled?: boolean;
  rows?: number;
  maxLength?: number;
  autoSize?: boolean;
  resizable?: 'none' | 'vertical' | 'horizontal' | 'both';
  className?: string;
  id: string;
  onChange?: (event: TextAreaChangeEvent) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  prefix?: React.JSX.Element;
  suffix?: React.JSX.Element;
};

export const KendoReactTextArea = (props: KendoReactTextAreaProps) => {
  const {
    value,
    defaultValue,
    placeholder,
    disabled = false,
    rows,
    maxLength,
    autoSize = true,
    resizable = 'none',
    className = '',
    id,
    onChange,
    onKeyDown,
    prefix,
    suffix
  } = props;

  return (
    <div className="kendo-react-text-area" data-testid="kendo-react-text-area">
      <link
        href="https://kendo.cdn.telerik.com/themes/7.0.1/material/material-main.css"
        rel="stylesheet"
        type="text/css"
      />
      <KendoTextArea
        className={className}
        id={id}
        value={value}
        defaultValue={defaultValue}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        maxLength={maxLength}
        autoSize={autoSize}
        resizable={resizable}
        onChange={onChange}
        onKeyDown={onKeyDown}
        prefix={prefix && <InputPrefix>{prefix}</InputPrefix>}
        suffix={suffix && <InputSuffix>{suffix}</InputSuffix>}
      />
    </div>
  );
};

export type {
  TextAreaChangeEvent,
  TextAreaProps
} from '@progress/kendo-react-inputs';
